import React from 'react';
import { Modal, ModalProps, useWindowDimensions } from 'react-native';
import styled from 'styled-components/native';

import Button from './Button';
import { H5, P } from './Typography';
import Spacer from './Spacer';
import accessibilityTags from '../../accessibilityTags';

export type ConfirmDialogProps = ModalProps & {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  customButtonLabel?: string;
  onCustomButtonClicked?: () => void;
  onConfirmButtonClicked?: () => void;
  onCancelButtonClicked?: () => void;
};

const StyledDimContainer = styled.View`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  align-items: center;
  justify-content: center;
`;

const StyledDialog = styled.View<{ isDesktop: boolean }>`
  width: 90%;
  max-width: ${p => (p.isDesktop ? 480 : 420)}px;
  border-radius: 10px;
  overflow: hidden;
  background-color: white;
  padding: 40px 24px 24px 24px;
  align-items: center;
`;

const StyledButtonContainer = styled.View`
  max-width: 280px;
  width: 100%;
`;

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  title,
  message,
  confirmLabel = 'Ok',
  cancelLabel = 'Cancel',
  customButtonLabel,
  onCustomButtonClicked,
  onCancelButtonClicked,
  onConfirmButtonClicked,
  ...props
}) => {
  const window = useWindowDimensions();
  const isDesktop = window.width >= 768;
  return (
    <Modal animationType='fade' transparent {...props}>
      <StyledDimContainer>
        <StyledDialog isDesktop={isDesktop}>
          <H5 color='dark' padding={3} center>
            {title}
          </H5>
          <P padding={4} center>
            {message}
          </P>
          <StyledButtonContainer>
            <Button accessibilityLabel={accessibilityTags.confirmDialogYesID} testID={accessibilityTags.confirmDialogYesID} fullWidth size='small' onPress={onConfirmButtonClicked}>
              {confirmLabel}
            </Button>
            <Spacer size={2} />
            {customButtonLabel && onCustomButtonClicked && (
              <>
                <Button
                  outlined
                  fullWidth
                  size='small'
                  onPress={onCustomButtonClicked}
                >
                  {customButtonLabel}
                </Button>
                <Spacer size={2} />
              </>
            )}
            <Button
              accessibilityLabel={accessibilityTags.confirmDialogNoID}
              testID={accessibilityTags.confirmDialogNoID}
              outlined
              fullWidth
              size='small'
              onPress={onCancelButtonClicked}
            >
              {cancelLabel}
            </Button>
          </StyledButtonContainer>
        </StyledDialog>
      </StyledDimContainer>
    </Modal>
  );
};

export default ConfirmDialog;
